/** Response shape of the previews endpoint (structurally compatible with backend DTO, including nulls). */
export type PdfPreviewsResponse = {
  pageCount?: number | null;
  previews?: Array<{
    page?: number | null;
    content?: string | null;
  }> | null;
};

export function getPreviewImageSrc(content: string): string {
  if (content.startsWith("data:") || content.startsWith("http")) {
    return content;
  }

  const mime = content.startsWith("/9j/") ? "image/jpeg" : "image/png";
  return `data:${mime};base64,${content}`;
}

export function mapPdfPreviewsResponse(data: Pick<PdfPreviewsResponse, "pageCount" | "previews">) {
  const firstPreview = data.previews?.[0];

  return {
    pageCount: data.pageCount ?? 0,
    previewSrc: firstPreview?.content ? getPreviewImageSrc(firstPreview.content) : null,
  };
}
